import Avatar from '../avatar';
import Chevron from '../../../navigationMenu/components/chevron';
import { DealerManagementService } from 'src/services/dealer-management.service';
import ImageLogo from '../../../../../../assets/images/de-full-logo.png';
import { isAllow } from '../../../../../../utils/helpers';
import { isNavigationAvailable } from '../../../../utils/helpers';
import { isSiteCanadian } from '../../../../../../utils/helpers';
import { IUser } from '../../../../../../utils/interfaces/user';
import { Langlist } from '../menuLang';
import MenuItem from './menuItem';
import { profileLinks } from '../profileItems';
import Spinner from 'src/components/ui/spinner';
import { useLocalization } from 'src/utils/useLocalization';
import { useLocation } from 'react-router-dom';
import { USER_ACTIONS } from '../../../../../../utils/enums/user-store-actions.enum';
import { useTranslation } from 'react-i18next';
import {
    ASSOCIATIONS_NAME,
    FULL_NAME,
    USER_NAME,
} from '../../../../../../config';
import {
    LABEL_TEXT_MENU_LANGUAGE,
    LABEL_TEXT_MENU_PROFILE,
    LABEL_TEXT_MENU_PROFILE_LANG_ENGLISH,
} from '../../../../../../localization/resouceKeys';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './styles.scss';

export interface IRoute {
    name: string;
    icon?: string;
    path: string;
    permissions?: Array<string>;
    childs?: Array<{
        name: string;
        path: string;
        handler?: any;
        permissions?: Array<string>;
    }>;
}

interface IRoutes {
    routes: Array<IRoute>;
    permissionsMap: Map<string, Array<string>>;
    names: Array<{ dealerId: string; name: string }>;
}

interface IDealerMenuList {
    name: string;
    path?: string;
    handler?: any;
}

const ResponsiveMenu = ({ routes, permissionsMap, names }: IRoutes) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { labelText } = useLocalization();
    const excludedRoutes = ['/terms-and-conditions'];
    const [loading, setLoading] = useState<boolean>(false);
    const [oldDistrict, setOldDistrict] = useState<string>('');
    const permissionsToken = useSelector(
        (state: IUser) => state.permissionsToken,
    );
    const currentDealers = useSelector((state: IUser) => state.currentDealers);
    const accessUser = useSelector((state: IUser) => state.accessUser);
    const selectedDistrics = useSelector(
        (state: IUser) => state.selectedDistrics,
    );
    const districs = useSelector((state: IUser) => state.districs);
    const { i18n, t } = useTranslation();
    const [person, setPerson] = useState({
        name: ' ',
        email: '',
    });
    const [selected, setSelected] = useState<string>('');
    const [selectedDist, setSelectedDist] = useState<string>('');
    const [selectedLang, setSelectedLang] = useState<string>(
        LABEL_TEXT_MENU_PROFILE_LANG_ENGLISH,
    );
    const [activeSelect, setActiveSelect] = useState<string>('dealers');
    const [open, setOpen] = useState<boolean>(false);
    const [submenu, setSubMenu] = useState<{
        title: string;
        links: Array<{ name: string; path: string; handler?: any }>;
    }>({ title: '', links: [] });
    function buildSubmenu(title: string, links: any) {
        setSubMenu({
            title,
            links,
        });
    }
    function showLang() {
        const index = Langlist.findIndex((e) => e && e.name === selectedLang);
        return Langlist[index].accron;
    }
    const [dealers, setDealers] = useState<Array<IDealerMenuList>>([]);
    const [districsList, setDistrictsList] = useState<Array<any>>([]);
    useEffect(() => {
        if (permissionsToken) {
            const fullname = sessionStorage.getItem(FULL_NAME);
            const username = sessionStorage.getItem(USER_NAME);
            if (fullname && username) {
                setPerson({
                    name: fullname,
                    email: username,
                });
            }
        }
    }, [permissionsToken]);
    useEffect(() => {
        if (accessUser) {
            const init: any[] = [];
            let aux: any[] = [];
            if (districs?.length) {
                aux = districs.length
                    ? districs?.map((ele: { districtId: string }) => {
                          return {
                              name: `${labelText.LABEL_TEXT_DASH_DISTRICT} ${ele.districtId}`,
                              handler: () => {
                                  setSelectedDist(`${ele.districtId}`);
                                  dispatch({
                                      type: USER_ACTIONS.SET_DEFAULT_DISTRICT,
                                      payload: ele.districtId,
                                  });
                              },
                          } as IDealerMenuList;
                      })
                    : [];
            }
            setDistrictsList(init.concat(aux));
        }
    }, [districs]);
    useEffect(() => {
        if (!accessUser) {
            let aux: IDealerMenuList[] = [];
            if (currentDealers?.dealers) {
                aux = currentDealers.dealers.length
                    ? currentDealers?.dealers.map(
                          (ele: { dealerId: string }) => {
                              let dealerName = '';
                              if (names) {
                                  const name = names.find(
                                      (d) => d.dealerId === ele.dealerId,
                                  );
                                  dealerName = name ? ` - ${name.name}` : '';
                              }
                              return {
                                  name: `${ele.dealerId}${dealerName}`,
                                  handler: () => {
                                      setSelected(`${ele.dealerId}`);
                                      dispatch({
                                          type: USER_ACTIONS.SET_DEFAULT_DEALER,
                                          payload: ele.dealerId,
                                      });
                                  },
                              } as IDealerMenuList;
                          },
                      )
                    : [];
                setDealers(aux);
                setSelected(currentDealers ? `${currentDealers?.default}` : '');
            }
        } else {
            if (selectedDistrics && oldDistrict !== selectedDistrics) {
                getDealerById(selectedDistrics);
            }
        }
    }, [currentDealers, names, accessUser, selectedDistrics]);
    delete Langlist[0];
    const auxLang = Langlist.map((e) => {
        return {
            name: e.name,
            handler: () => {
                setSelectedLang(e.name);
                i18n.changeLanguage(
                    e.name.includes('English')
                        ? isSiteCanadian()
                            ? 'en-CA'
                            : 'en-US'
                        : 'fr-CA',
                );
            },
        };
    });
    async function getDealerNamesData(dealerIds: [string]) {
        const service = new DealerManagementService();
        try {
            const res = await service.getDealerNames(dealerIds);
            if (res && res.data) {
                const namesList = res.data.dealers.map((dealer: any) => {
                    return { dealerId: dealer.dealerId, name: dealer.name };
                });
                return namesList;
            }
        } catch (error) {
            console.error(error);
        }
    }
    async function getDealerById(selectedDistrics: any) {
        try {
            setLoading(true);
            const service = new DealerManagementService();
            const res = await service.getDealerNamesByDistrict(
                selectedDistrics,
            );
            if (res.data.dealerIds.length) {
                const dealers: Array<{ dealerId: string }> = [];
                res.data.dealerIds.map(
                    (ele: { manufacturerUniqueId: string }) => {
                        dealers.push({ dealerId: ele.manufacturerUniqueId });
                    },
                );
                const newNames = await getDealerNamesData(
                    res.data.dealerIds.map(
                        (ele: { manufacturerUniqueId: string }) =>
                            ele.manufacturerUniqueId,
                    ),
                );
                const aux = res.data.dealerIds.map(
                    (ele: { manufacturerUniqueId: string }) => {
                        let dealerName = '';
                        if (newNames) {
                            const name = names.find(
                                (d) => d.dealerId === ele.manufacturerUniqueId,
                            );
                            dealerName = name ? ` - ${name.name}` : '';
                        }
                        return {
                            name: `${ele.manufacturerUniqueId}${dealerName}`,
                            handler: () => {
                                setSelected(`${ele.manufacturerUniqueId}`);
                                dispatch({
                                    type: USER_ACTIONS.SET_DEFAULT_DEALER,
                                    payload: ele.manufacturerUniqueId,
                                });
                            },
                        } as IDealerMenuList;
                    },
                );
                setDealers(aux);
                setOldDistrict(selectedDistrics);
                sessionStorage.setItem(ASSOCIATIONS_NAME, JSON.stringify(aux));
                dispatch({
                    type: USER_ACTIONS.SET_DEALERS,
                    payload: {
                        default: undefined,
                        aux,
                    },
                });
                setSelected('');
            }
            setLoading(false);
        } catch (e) {
            setLoading(false);
        }
    }
    function closeMenu() {
        setOpen(false);
        setSubMenu({ title: '', links: [] });
    }
    const visibleRoutes =
        !accessUser ||
        isNavigationAvailable(
            accessUser,
            selectedDistrics,
            currentDealers?.default,
        )
            ? routes
            : [];
    return (
        <div className={'responsive-menu'}>
            <div className={'responsive-menu__menu'}>
                {!excludedRoutes.includes(location.pathname) && !open ? (
                    <a
                        href={'#'}
                        className={'responsive-menu__menu-icon'}
                        onClick={() => setOpen(true)}
                    >
                        <i className={'c-icon c-icon--[semantic-menu]'}></i>
                    </a>
                ) : null}
            </div>
            <div
                className={'responsive-menu__logo'}
                style={{
                    justifyContent: open
                        ? submenu.title
                            ? 'space-between'
                            : 'end'
                        : 'center',
                }}
            >
                {open ? (
                    <>
                        {submenu.links.length ? (
                            <>
                                <a
                                    href={'#'}
                                    className={'responsive-menu__menu-back'}
                                    onClick={() => {
                                        setSubMenu({
                                            title: '',
                                            links: [],
                                        });
                                    }}
                                >
                                    <i
                                        className={
                                            'c-icon c-icon--[chevron-left]'
                                        }
                                    ></i>
                                </a>
                                <span>{t(submenu.title)}</span>
                            </>
                        ) : null}
                        <a
                            href={'#'}
                            className={'responsive-menu__menu-cross'}
                            onClick={() => {
                                setOpen(false);
                                setSubMenu({ title: '', links: [] });
                            }}
                        >
                            <i className={'c-icon c-icon--[semantic-close]'} />
                        </a>
                    </>
                ) : (
                    <img src={ImageLogo} height={15} width={140} alt={'logo'} />
                )}
            </div>
            {open && (
                <div className={'responsive-menu__list'}>
                    <ul className={'c-icon-list'}>
                        {submenu.links.length ? (
                            submenu.links.map((ele, key) => {
                                if (ele.path || ele.handler)
                                    return (
                                        <MenuItem
                                            name={ele.name}
                                            path={ele.path}
                                            handler={ele.handler}
                                            selected={
                                                activeSelect === 'distric'
                                                    ? selected
                                                    : selectedLang
                                            }
                                            selectedIcon={'semantic-checkmark'}
                                            dealer={currentDealers?.default}
                                            permissionsMap={permissionsMap}
                                            key={key}
                                            onNavigate={closeMenu}
                                        />
                                    );
                            })
                        ) : (
                            <>
                                <li className={'menu-items profile'}>
                                    <a
                                        onClick={() => {
                                            buildSubmenu(
                                                LABEL_TEXT_MENU_PROFILE,
                                                profileLinks,
                                            );
                                        }}
                                    >
                                        <div className={'flex align'}>
                                            <Avatar name={person.name} />
                                            {person.name}
                                        </div>
                                        <Chevron width={10} fill={'#777'} />
                                    </a>
                                </li>
                                {accessUser ? (
                                    <li
                                        className={
                                            'menu-items district dealership'
                                        }
                                    >
                                        <a
                                            onClick={() => {
                                                setActiveSelect('district');
                                                buildSubmenu(
                                                    'Districts',
                                                    districsList,
                                                );
                                            }}
                                        >
                                            <div className={'flex'}>
                                                <i
                                                    className={
                                                        'c-icon-list__icon c-icon c-icon--[find-a-dealer]'
                                                    }
                                                    aria-hidden='true'
                                                    role='img'
                                                />
                                                {!!selectedDist
                                                    ? `${labelText.LABEL_TEXT_DASH_DISTRICT} ${selectedDist}`
                                                    : `${labelText.LABEL_TEXT_DASH_SELECT} ${labelText.LABEL_TEXT_DASH_DISTRICT}`}
                                            </div>
                                            <Chevron width={10} fill={'#777'} />
                                        </a>
                                    </li>
                                ) : null}
                                <li className={'menu-items dealership'}>
                                    <a
                                        onClick={() => {
                                            setActiveSelect('dealer');
                                            buildSubmenu('Dealership', dealers);
                                        }}
                                    >
                                        <div className={'flex'}>
                                            <i
                                                className={
                                                    'c-icon-list__icon c-icon c-icon--[semantic-dealer]'
                                                }
                                                aria-hidden='true'
                                                role='img'
                                            />
                                            {selected
                                                ? selected
                                                : accessUser
                                                ? `${labelText.LABEL_TEXT_DASH_SELECT} ${labelText.LABEL_TEXT_DASH_DEALERSHIP}`
                                                : ''}
                                            {loading ? (
                                                <span
                                                    style={{
                                                        width: 10,
                                                        height: 10,
                                                        display: 'block',
                                                        marginLeft: '1.25rem',
                                                    }}
                                                >
                                                    <Spinner />
                                                </span>
                                            ) : null}
                                        </div>
                                        <Chevron width={10} fill={'#777'} />
                                    </a>
                                </li>
                                {isSiteCanadian() ? (
                                    <li className={'menu-items language'}>
                                        <a
                                            onClick={() => {
                                                setActiveSelect('lang');
                                                buildSubmenu(
                                                    LABEL_TEXT_MENU_LANGUAGE,
                                                    auxLang,
                                                );
                                            }}
                                        >
                                            <div className={'flex'}>
                                                <i
                                                    className={
                                                        'c-icon-list__icon c-icon c-icon--[globe]'
                                                    }
                                                    aria-hidden='true'
                                                    role='img'
                                                />
                                                {showLang()}
                                            </div>
                                            <Chevron width={10} fill={'#777'} />
                                        </a>
                                    </li>
                                ) : null}
                                {visibleRoutes.map((ele, key) => {
                                    const children: Array<{
                                        name: string;
                                        path: string;
                                        handler?: any;
                                        permissions?: Array<string>;
                                    }> = [];
                                    const baseIndex = 0;
                                    if (ele.childs) {
                                        ele.childs.forEach((e) => {
                                            const shouldRender = e.permissions
                                                ? isAllow(
                                                      e.permissions,
                                                      permissionsMap,
                                                      currentDealers?.default,
                                                  )
                                                : true;

                                            if (shouldRender) {
                                                children.push(e);
                                            }
                                        });
                                    }

                                    const isRestricted =
                                        ele.childs &&
                                        ele.childs.length > baseIndex &&
                                        children.length == baseIndex;

                                    return !isRestricted ? (
                                        <MenuItem
                                            name={ele.name}
                                            childs={children}
                                            icon={ele.icon}
                                            path={ele.path}
                                            handler={() =>
                                                setSubMenu({
                                                    title: ele.name,
                                                    links: children,
                                                } as any)
                                            }
                                            permissionsMap={permissionsMap}
                                            permissions={ele.permissions}
                                            dealer={currentDealers?.default}
                                            key={key}
                                            onNavigate={closeMenu}
                                        />
                                    ) : null;
                                })}
                            </>
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default ResponsiveMenu;
